import { useTranslation } from "react-i18next";

import WidgetsGrid from "@/components/Elements/WidgetsGrid";
import BaseHeader from "@/components/Header/BaseHeader";
import { PROJECTS_STATISTICS_WIDGETS } from "@/components/ListStatistics/Projects";
import ProjectsTable from "@/components/ListTable/ProjectsTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { AppLayoutPage } from "@/modules/app-layout/app-layout-page";
import { ListProvider } from "@/modules/list";
import ProjectAddButton from "@/modules/project/project-add-button";

const Projects = () => {
  const { t } = useTranslation();

  return (
    <>
      <BaseHeader
        title={t("navigation:projects")}
        extra={[<ProjectAddButton key="project-add-button" />]}
      />
      <AppLayoutPage>
        <ListProvider
          endpoint="projects"
          storageKey={STORAGE_KEYS.PROJECTS}
          withMetadata={["statistics"]}
          withContext
        >
          <WidgetsGrid widgets={PROJECTS_STATISTICS_WIDGETS}>
            <ProjectsTable showLocationColumn />
          </WidgetsGrid>
        </ListProvider>
      </AppLayoutPage>
    </>
  );
};

export default Projects;
